/** Minimum column width in px; columns never drag below this. */
export const MIN_COLUMN_WIDTH = 80;

/** Round to an integer px and floor at the minimum. */
export function clampWidth(px: number): number {
  return Math.max(MIN_COLUMN_WIDTH, Math.round(px));
}

/** Start width + drag delta, clamped to the minimum. */
export function nextWidth(startWidth: number, deltaX: number): number {
  return clampWidth(startWidth + deltaX);
}

/** localStorage key for a grid's persisted column widths. */
export function storageKey(gridId: string): string {
  return `datagrid:width:${gridId}`;
}

/** Read the persisted width map; returns `{}` on missing/malformed data or no localStorage. */
export function readWidths(gridId: string): Record<string, number> {
  if (typeof window === 'undefined') return {};
  try {
    const raw = window.localStorage.getItem(storageKey(gridId));
    if (!raw) return {};
    const parsed: unknown = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? (parsed as Record<string, number>) : {};
  } catch {
    return {};
  }
}

/** Persist the full width map (best-effort; no-ops if localStorage is unavailable). */
export function writeWidths(gridId: string, widths: Record<string, number>): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(storageKey(gridId), JSON.stringify(widths));
  } catch {
    /* storage full / disabled - resize still works in-session */
  }
}
